import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-crm-cta',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './crm-cta.html',
  styleUrls: ['./crm-cta.css'],
})
export class CrmCtaComponent {}
